import React from 'react';

const FeaturesSection = () => {
  return (
    <section className="py-24 bg-surface-container-lowest/80 backdrop-blur-md reveal-on-scroll">
      <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop">
        <div className="text-center mb-16">
          <h2 className="font-headline-md text-headline-md mb-4">Why Traders Choose <span className="text-primary">Algo Forex EA</span></h2>
          <p className="text-on-surface-variant">Premium quality Expert Advisors without the premium price tag.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-gutter-desktop">
          <div className="text-center p-8 stagger-item">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6 text-primary">
              <span className="material-symbols-outlined text-3xl">payments</span>
            </div>
            <h4 className="font-bold text-headline-sm mb-4">Cheaper Than MQL5</h4>
            <p className="text-on-surface-variant">Why pay $499 when you can get the same EA for $79? We source premium Expert Advisors and offer them at 60–80% below MQL5 market prices.</p>
          </div>
          <div className="text-center p-8 stagger-item">
            <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mx-auto mb-6 text-secondary">
              <span className="material-symbols-outlined text-3xl">verified</span>
            </div>
            <h4 className="font-bold text-headline-sm mb-4">Verified Backtest Results</h4>
            <p className="text-on-surface-variant">Every EA on our platform comes with independently verified backtest data—win rates, drawdown metrics, profit factors, and monthly return charts.</p>
          </div>
          <div className="text-center p-8 stagger-item">
            <div className="w-16 h-16 rounded-full bg-surface-tint/10 flex items-center justify-center mx-auto mb-6 text-surface-tint">
              <span className="material-symbols-outlined text-3xl">dynamic_feed</span>
            </div>
            <h4 className="font-bold text-headline-sm mb-4">Request Any EA</h4>
            <p className="text-on-surface-variant">Can't find the EA you need? Send us the MQL5 link and we'll source it for you within 24 hours—at our discounted price. Just paste the link and we handle the rest.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
